import { BlueCheckbox as Checkbox } from '@/gf/components/Checkbox'
import TextArea from '@/gf/components/TextArea'

const CustomerComments: React.FC<{
  send: boolean
  setSend: (newSend: boolean) => void
  comments: string
  setComments: (newComments: string) => void
}> = ({ send, setSend, comments, setComments }) => (
  <div className="space-y-4">
    <Checkbox
      label="Notify Customer (sends email)"
      id="send-approve-email"
      checked={send}
      onChange={(e) => setSend(e.target.checked)}
    />

    {send && (
      <div className="space-y-1">
        <p>Additional comments:</p>

        <p className="font-medium">
          The comments below will be included in the customer notification.
        </p>

        <TextArea className="mt-2" value={comments} onChange={(e) => setComments(e.target.value)} />
      </div>
    )}
  </div>
)

export default CustomerComments
